import BottomBeaconSpacer from '@src/lib/BottomBeaconSpacer'

import PendingBrandRequests from './PendingBrandRequests'

function AddBrands() {
  return (
    <>
      <PendingBrandRequests />
      <BottomBeaconSpacer />
    </>
  )
}

export default AddBrands
